export class SessionStorageCache {
    setItem(key: string, value: any): void {
        try {
            const serializedValue = JSON.stringify(value);
            sessionStorage.setItem(key, serializedValue);
        } catch (error) {
            console.warn('Error saving to local storage', error);
        }
    }

    getItem(key: string): any {
        try {
            const serializedValue = sessionStorage.getItem(key);
            return serializedValue ? JSON.parse(serializedValue) : null;
        } catch (error) {
            console.warn('Error reading from local storage', error);
            return null;
        }
    }

    removeItem(key: string): void {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.warn('Error removing from local storage', error);
        }
    }

    clear(): void {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.warn('Error clearing local storage', error);
        }
    }
}
